const iterableKeys = [
    'e',
    'n',
    'k',
    'd',
    'p',
    'q',
    'dp',
    'dq',
    'qi'
];
export function mapJsonWebKey(key, mapper) {
    return iterableKeys.reduce((obj, k) => {
        if (key[k]) {
            const v = key[k] || '';
            const mapped = mapper(v);
            obj[k] = mapped;
        }
        return obj;
    }, { ...key });
}
